import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SthandarshanComponent } from './sthandarshan.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { HttpClient } from '@angular/common/http';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';


@NgModule({
  declarations: [
    SthandarshanComponent
  ],
  imports: [
    CommonModule,
    GoogleMapsModule,
    AutocompleteLibModule
  ],
  providers:[HttpClient]
})
export class SthandarshanModule { }
